export const isUrl = (text: string) => {
  const urlRegExp = /^(http:\/\/|https:\/\/|www.)/;
  return text === "" || urlRegExp.test(text);
};

export const addHttpIfNeeded = (url: string) => {
  if (url.includes("http")) return url;
  return "https://" + url;
};
